import $ from 'jquery';
import TeaserFadeView from './TeaserFadeView';
import TeaserBulletView from './TeaserBulletView';
import TeaserListView from './TeaserListView';
import TeaserSlideView from './TeaserSlideView';
import { register } from '../core/bootstrapper';

register(null, () => {
  $('.main-teaser').each(function() {
    new TeaserFadeView({
      el: $(this)
    });
  });

  $('.bullet-teaser').each(function() {
    new TeaserBulletView({
      el: $(this)
    });
  });

  $('.new-teaser').each(function() {
    new TeaserListView({
      el: $(this)
    });
  });

  $('.slide-teaser').each(function() {
    new TeaserSlideView({
      el: $(this)
    });
  });
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/teaserBootstrap.js
 **/